const VERSION = localStorage.getItem("front_app_version") ?? "v1.0.0";

export default VERSION;